import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'PaymentMethod';
const ENDPOINT = `/payment-methods/`;

@Injectable({
    providedIn: 'root'
})
export class PaymentMethodService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
